<template>
    <div class="agree key-policy-points">
        <div class="row">
            <div class="col-10">
                <h3>Key Policy Points</h3>
                <p><strong>[UNKNOWN] No text source, where is this saved in
                    API?</strong></p>
                <ul>
                    <li>I confirm that duis mollis, est non commodo luctus, nisi
                        erat porttitor ligula, eget lacinia odio sem nec elit.
                    </li>
                    <li>I confirm that morbi leo risus, porta ac consectetur ac,
                        vestibulum at eros. Donec ullamcorper nulla non metus
                        auctor fringilla. Morbi leo risus, porta ac consectetur
                        ac, vestibulum at eros.
                    </li>
                    <li>I confirm that lorem ipsum dolor sit amet, consectetur
                        adipiscing elit. Nullam id dolor id nibh ultricies
                        vehicula ut id elit. Aenean eu leo quam. Pellentesque
                        ornare sem lacinia quam venenatis vestibulum.
                    </li>
                </ul>
            </div>
            <div class="col-2">
                <div class="d-flex align-items-end flex-column h-100">
                    <div class="mt-auto position-relative w-100">
                        <input type="checkbox" name="confirm" id="confirm"
                               class="confirm" v-model="keyPolicyPoints">
                        <label for="confirm"></label>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
    },
    data: () => {
        return {
            keyPolicyPoints: null,
        }
    },
    watch: {
        keyPolicyPoints(value){
            this.$parent.confirmations.keyPolicyPoints = value;
        },
    },
};
</script>
